import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";

import request from "superagent";
import { url_endpoint, url_s3, clientTypes, baseUrlPlugPlayer, blogPlayClientType, plugClientType } from "../../config";
import authHeader from "../Utils/AuthHeader";
import { IconButton } from "@material-ui/core";
import ButtonLogout from "../../componentes/ButtonLogout";
import LoaderSpinner from "../../componentes/LoaderSpinner";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import checkLogin from "../Utils/checkLogin";
import { Assignment } from "@material-ui/icons";
const moment = require("moment");

const useStyles = (theme) => ({
  root: {
    flexGrow: 1,
  },
  input_hidde: {
    display: "none",
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
});

let imageUpload;
class Cliente extends Component {
  constructor(props) {
    super(props);
    this.state = {
      insert: {
        nome: "",
        email: "",
        login: "",
        site: "",
        senha: "",
        descricao: "",
        titulo_podcast: "",
        imagem: "",
        categoria: -1,
        img: "",
        img_logo: "",
        imageWidth: 0,
        imageHeight: 0,
        nomeAuthor: "",

        url_post_spotify: "",
        url_post_itunes: "",
        url_post_google: "",

        clientType: 0,

        titleSelector: '',
        bodySelector: '',
        monthlyCharacters: 0,
        paymentOnTime: true,

        monthlyAudios: 0,
      },
      id_editar: -1,
      dados: [],
      loading: false,
      openDialog: false,
      message: "",
      imageValid: true,
      logoPreviewUrl: null,
      imagePreviewUrl: null,
      windowHeight: 0,
      actualPage: 0
    };
    this.category =
      "Arts,Books,Design,Fashion & Beauty,Food,Performing Arts,Visual Arts,Business,Careers,Entrepreneurship,Investing,Management,Marketing,Non-Profit,Comedy,Comedy Interviews,Improv,Stand-Up,Education,Courses,How To,Language Learning,Self-Improvement,Fiction,Comedy Fiction,Drama,Science Fiction,Government,History,Health &amp; Fitness,Alternative Health,Fitness,Medicine,Mental Health,Nutrition,Sexuality,Kids &amp; Family,Education for Kids,Parenting,Pets &amp; Animals,Stories for Kids,Leisure,Animation &amp; Manga,Automotive,Aviation,Crafts,Games,Hobbies,Home &amp; Garden,Video Games,Music,Music Commentary,Music History,Music Interviews,News,Business News,Daily News,Entertainment News,News Commentary,Politics,Sports News,Tech News,Religion &amp; Spirituality,Buddhism,Christianity,Hinduism,Islam,Judaism,Religion,Spirituality,Science,Astronomy,Chemistry,Earth Sciences,Life Sciences,Mathematics,Natural Sciences,Nature,Physics,Social Sciences,Society &amp; Culture,Documentary,Personal Journals,Philosophy,Places &amp; Travel,Relationships,Sports,Baseball,Basketball,Cricket,Fantasy Sports,Football,Golf,Hockey,Rugby,Running,Soccer,Swimming,Tennis,Volleyball,Wilderness,Wrestling,Technology,True Crime,TV &amp; Film,After Shows,Film History,Film Interviews,Film Reviews,TV Reviews";
  }

  handleClose = () => {
    this.setState({ openDialog: false, message: "" });
  };

  inserir_editar = async () => {
    try {
      if (!this.state.imageValid) {
        alert("A imagem capa não esta no padrão correto!");
        return;
      } else if (
        !this.state.insert.nome ||
        this.state.insert.nome.trim().length === 0
      ) {
        alert("Informe o nome!");
        return;
      } else if (
        !this.state.insert.login ||
        this.state.insert.login.trim().length === 0
      ) {
        alert("Informe o login!");
        return;
      } else if (
        !this.state.insert.titulo_podcast ||
        this.state.insert.titulo_podcast.trim().length === 0
      ) {
        alert("Informe o titulo do podcast!");
        return;
      } else if (this.state.id_editar === -1 && !this.state.insert.img) {
        alert("Selcione uma imagem!");
        return;
      } else if (this.state.insert.clientType == 1 && (this.state.insert.monthlyCharacters == null || this.state.insert.monthlyCharacters == 0)) {
        alert('O limite de carácteres é obrigatório e deve ser maior que 0!')
        return
      } else {
        this.setState({ loading: true });

        let method = "post";
        let url_plus = "";
        if (this.state.id_editar >= 0) {
          method = "put";
          url_plus = "/" + this.state.id_editar;
        }

        const res = await request(method, url_endpoint + "cliente" + url_plus)
          .set(authHeader())
          .attach("foto", this.state.insert.img)
          .attach("img_logo", this.state.insert.img_logo)
          .field("nome", this.state.insert.nome || '')
          .field("email", this.state.insert.email || '')
          .field("login", this.state.insert.login || '')
          .field("site", this.state.insert.site || '')
          .field("senha", this.state.insert.senha || '')
          .field("descricao", this.state.insert.descricao || '')
          .field("categoria", this.state.insert.categoria || -1)
          .field("imageWidth", this.state.insert.imageWidth || 0)
          .field("imageHeight", this.state.insert.imageHeight || 0)
          .field("nomeAuthor", this.state.insert.nomeAuthor || '')
          .field("titulo_podcast", this.state.insert.titulo_podcast || '')

          .field("url_post_spotify", this.state.insert.url_post_spotify || '')
          .field("url_post_itunes", this.state.insert.url_post_itunes || '')
          .field("url_post_google", this.state.insert.url_post_google || '')

          .field("clientType", this.state.insert.clientType || 0)

          .field("titleSelector", this.state.insert.titleSelector || '')
          .field("bodySelector", this.state.insert.bodySelector || '')

          .field("monthlyAudios", this.state.insert.monthlyAudios || '')

          .field("monthlyCharacters", this.state.insert.monthlyCharacters || 0)

          .field("paymentOnTime", this.state.insert.paymentOnTime) || true;

        this.setState({ loading: false });

        const dados = this.state.dados;
        if (this.state.id_editar >= 0) {
          dados[dados.findIndex((item) => item.id === this.state.id_editar)] =
            res.body;
        } else {
          dados.push(res.body);
        }

        this.setState({
          dados,
          id_editar: -1,
          insert: {
            nome: "",
            login: "",
            email: "",
            site: "",
            senha: "",
            categoria: -1,
            titulo_podcast: "",
            img: "",
            img_logo: "",
            url_post_spotify: "",
            url_post_itunes: "",
            url_post_google: "",
            imageWidth: 0,
            imageHeight: 0,
            nomeAuthor: "",
            clientType: 0,
            titleSelector: '',
            monthlyAudios: 0,
            bodySelector: '',
            monthlyCharacters: 0,
            paymentOnTime: true,
            descricao: '',
          },
        });
        alert('Usuário salvo com sucesso!')
      }
    } catch (err) {
      this.setState({ loading: false });
      alert(err);
    }
  };
  changeField = (field, value) => {
    const insert = this.state.insert;
    insert[field] = value.target.value;
    this.setState({ insert });
  };

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  async componentDidMount() {
    try {
      await checkLogin(true)
      this.setState({ loading: true });
      this.handleResize();
      window.addEventListener("resize", this.handleResize);

      const res = await request.get(url_endpoint + "cliente/" + this.state.actualPage).set(authHeader());
      this.setState({ loading: false });

      this.setState({ dados: res.body });
    } catch (err) {
      this.setState({ loading: false });
      alert(err);
      window.location = "/";
    }
  }

  editar(item) {
    const insert = this.state.insert;
    insert.nome = item.nome;
    insert.login = item.login;
    insert.email = item.email;
    insert.site = item.site;
    insert.categoria = item.categoria;
    insert.nomeAuthor = item.nomeAuthor;

    insert.imageWidth = item.imageWidth ? item.imageWidth : 0;
    insert.imageHeight = item.imageHeight ? item.imageHeight : 0;

    insert.url_post_spotify = item.url_post_spotify
      ? item.url_post_spotify
      : "";
    insert.url_post_itunes = item.url_post_itunes ? item.url_post_itunes : "";
    insert.url_post_google = item.url_post_google ? item.url_post_google : "";

    insert.titulo_podcast = item.titulo_podcast;

    insert.clientType = item.clientType

    insert.titleSelector = item.titleSelector
    insert.bodySelector = item.bodySelector

    insert.monthlyAudios = item.monthlyAudios

    insert.monthlyCharacters = item.monthlyCharacters

    insert.paymentOnTime = item.paymentOnTime

    const imageLink = item.imagem.includes('digitalocean') ? item.imagem : url_s3 + item.imagem
    const logoLink = item.img_logo.includes('digitalocean') ? item.img_logo : url_s3 + item.img_logo

    this.setState({
      insert,
      id_editar: item.id,
      imagePreviewUrl: imageLink,
      logoPreviewUrl: logoLink,
      imageValid: true,
    });
  }

  async excluir(id) {
    if (!window.confirm("Você tem certeza que deseja deletar este item?"))
      return;
    try {
      this.setState({ loading: true });

      await request.delete(url_endpoint + "cliente/" + id).set(authHeader());
      this.setState({ loading: false });

      const dados = this.state.dados;
      dados.splice(
        dados.findIndex((i) => i.id === id),
        1
      );
      this.setState({ dados });
    } catch (err) {
      this.setState({ loading: false });
      alert(err.response.text);
    }
  }

  /*     setImg = (evt) => {
            const insert = this.state.insert;
            insert.img = evt.target.files[0];
            //check image size
    
            imageUpload = document.createElement("img");
            this.state.backgroundImageFile = evt.target.files[0];
    
            imageUpload.onload = function () {
                if (this.width != this.height) {
                    alert("Essa imagem não esta com o tamanho correto para publicar nos agregadores! \n A imagem deve ser 1:1 (quadrada)!");
                } else if ((this.width < 1300 || this.width > 3000) || (this.height < 1300 || this.height > 3000)) {
                    alert("Essa imagem não esta com o tamanho correto para publicar nos agregadores! \n Tamanho ideal 1300x1300 e tamanho máximo 3000x3000 !");
                }
            }
            var reader = new FileReader();
            reader.onloadend = function (ended) {
                imageUpload.src = ended.target.result;
            }
            reader.readAsDataURL(evt.target.files[0]);
    
            this.setState({ insert });
        } */

  readImage = () => {
    const scope = this;
    if (this.state.insert.img) {
      var img = document.createElement("img");
      //this.setState({ imageValid: true });

      img.onload = function () {
        let insert = scope.state.insert;
        insert.imageWidth = this.width;
        insert.imageHeight = this.height;

        scope.setState({ insert: insert });
        if (this.width != this.height) {
          scope.setState({ imageValid: false });
        } else if (
          (this.width < 1400 || this.height < 1400) &&
          (this.width > 3000 || this.height > 3000)
        ) {
          scope.setState({ imageValid: false });
        } else {
          scope.setState({ imageValid: true });
        }
      };

      var reader = new FileReader();
      reader.onloadend = function (ended) {
        img.src = ended.target.result;
        scope.setState({ imagePreviewUrl: ended.target.result });
      };
      reader.readAsDataURL(this.state.insert.img);
    }
  };

  readImageLogo = () => {
    const scope = this;
    if (this.state.insert.img_logo) {
      var reader = new FileReader();
      reader.onloadend = function (ended) {
        scope.setState({ logoPreviewUrl: ended.target.result });
      };
      reader.readAsDataURL(this.state.insert.img_logo);
    }
  };

  setImg = async (evt) => {
    const insert = this.state.insert;
    insert.img = evt.target.files[0];
    await this.setState({ insert });
    this.readImage();
  };

  setImgLogo = async (evt) => {
    const insert = this.state.insert;
    insert.img_logo = evt.target.files[0];
    await this.setState({ insert });
    this.readImageLogo();
  };
  handleResize = () =>
    this.setState({
      windowHeight: window.innerHeight,
    });

  nextPage = async () => {
    this.setState({ loading: true })
    const lastPage = this.state.actualPage
    const newPage = lastPage + 1
    const res = await request.get(url_endpoint + "cliente/" + newPage).set(authHeader());
    if (res.body.length > 0) {
      this.setState({ loading: false, dados: res.body, actualPage: newPage })
    }
    else {
      this.setState({ loading: false })
      window.alert('Já está na última página.')
    }
  }

  prevPage = async () => {
    const lastPage = this.state.actualPage
    const newPage = lastPage - 1
    if (newPage < 0) {
      window.alert('Já está na primeira página')
    }
    else {
      this.setState({ loading: true, actualPage: newPage })
      const res = await request.get(url_endpoint + "cliente/" + newPage).set(authHeader());
      this.setState({ loading: false, dados: res.body })
    }
  }

  render() {
    const { classes } = this.props;
    const intFrameHeight = this.state.windowHeight - 42 + "px";
    return (
      <div style={{ height: intFrameHeight, overflow: "auto" }}>
        {this.state.loading && <LoaderSpinner />}
        <div className={"button-logout"}>
          <IconButton>
            <ButtonLogout />
          </IconButton>
        </div>
        <Dialog
          open={this.state.openDialog}
          onClose={this.handleClose}
          aria-labelledby="draggable-dialog-title"
        >
          <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
            {this.state.isExcluir
              ? "Informe o motivo da exclusão!"
              : "Înforme o que deseja alterar!"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <text
                value={this.state.message}
                style={{ width: "300px", height: "100px", color: "#5f5f5f" }}
              />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              {"OK"}
            </Button>
          </DialogActions>
        </Dialog>
        <div className={"insert-edit"}>
          <input
            className={"input-insert"}
            placeholder={"Nome"}
            type={"text"}
            value={this.state.insert.nome}
            onChange={(evt) => this.changeField("nome", evt)}
          />
          <input
            className={"input-insert"}
            placeholder={"Nome Author dos Áudios"}
            type={"text"}
            value={this.state.insert.nomeAuthor}
            onChange={(evt) => this.changeField("nomeAuthor", evt)}
          />

          <input
            className={"input-insert"}
            placeholder={"Login"}
            type={"text"}
            value={this.state.insert.login}
            onChange={(evt) => this.changeField("login", evt)}
          />

          <input
            className={"input-insert"}
            placeholder={"E-mail"}
            type={"text"}
            value={this.state.insert.email}
            onChange={(evt) => this.changeField("email", evt)}
          />

          <input
            className={"input-insert"}
            placeholder={"Título Podcast"}
            type={"text"}
            value={this.state.insert.titulo_podcast}
            onChange={(evt) => this.changeField("titulo_podcast", evt)}
          />

          <input
            className={"input-insert"}
            placeholder={"Descrição Podcast"}
            type={"text"}
            value={this.state.insert.descricao}
            onChange={(evt) => this.changeField("descricao", evt)}
          />

          <input
            className={"input-insert"}
            placeholder={"Site"}
            type={"text"}
            value={this.state.insert.site}
            onChange={(evt) => this.changeField("site", evt)}
          />

          <input
            className={"input-insert"}
            placeholder={"Senha"}
            type={"text"}
            value={this.state.insert.senha}
            onChange={(evt) => this.changeField("senha", evt)}
          />

          <input
            className={"input-insert"}
            placeholder={"URL Spotify"}
            type={"text"}
            value={this.state.insert.url_post_spotify}
            onChange={(evt) => this.changeField("url_post_spotify", evt)}
          />
          <input
            className={"input-insert"}
            placeholder={"URL Itunes"}
            type={"text"}
            value={this.state.insert.url_post_itunes}
            onChange={(evt) => this.changeField("url_post_itunes", evt)}
          />
          <input
            className={"input-insert"}
            placeholder={"URL Google"}
            type={"text"}
            value={this.state.insert.url_post_google}
            onChange={(evt) => this.changeField("url_post_google", evt)}
          />

          <select
            className={"input-insert"}
            name={"categoria"}
            onChange={(evt) => this.changeField("categoria", evt)}
            value={this.state.insert.categoria}
          >
            {this.category.split(",").map((item) => {
              return <option value={item}>{item}</option>;
            })}
          </select>

          {this.state.insert.clientType == blogPlayClientType &&
            <input
              className={"input-insert"}
              placeholder={"Áudios Mensais"}
              type={"number"}
              min={0}
              value={this.state.insert.monthlyAudios}
              onChange={(evt) => this.changeField("monthlyAudios", evt)}
            />
          }

          <select
            className={"input-insert"}
            name={"clientType"}
            onChange={(evt) => this.state.id_editar == -1 ? this.changeField("clientType", evt) : null}
            value={this.state.insert.clientType}
          >
            {clientTypes.map((item) => {
              return <option value={clientTypes.findIndex((i) => i == item)}>{item}</option>;
            })}
          </select>

          {this.state.insert.clientType == 1 &&
            <>
              <br />
              <input
                className={"input-insert"}
                placeholder={"Seletor de título"}
                type={"text"}
                value={this.state.insert.titleSelector}
                onChange={(evt) => this.changeField("titleSelector", evt)}
              />
              <input
                className={"input-insert"}
                placeholder={"Seletor de corpo"}
                type={"text"}
                value={this.state.insert.bodySelector}
                onChange={(evt) => this.changeField("bodySelector", evt)}
              />
              <input
                className={"input-insert"}
                placeholder={"Carácteres Mensais"}
                type={"number"}
                min={0}
                value={this.state.insert.monthlyCharacters}
                onChange={(evt) => this.changeField("monthlyCharacters", evt)}
              />
              <br />
              <label>Pagamento Em Dia:</label>
              <select
                className={"input-insert"}
                name={"paymentOnTime"}
                onChange={(evt) => this.changeField("paymentOnTime", evt)}
                value={this.state.insert.paymentOnTime}
              >
                <option value={true}>Sim</option>
                <option value={false}>Não</option>
              </select>
              {(this.state.insert.titleSelector != '' && this.state.insert.bodySelector != '') &&
                <>
                  <br />
                  <textarea style={{ width: '400px', height: '100px' }} readOnly={true} value={`<iframe id="plugIframe" style="height: 115px; min-width: 100%; border:none;" src="${baseUrlPlugPlayer}?id=${this.state.id_editar}"></iframe>\n<script src="https://plug-blogplay.s3.amazonaws.com/startPlug.js"></script>`}></textarea>
                  <br />
                  <IconButton style={{ padding: '0' }} onClick={navigator.clipboard.writeText(`<iframe id="plugIframe" style="height: 115px; min-width: 100%; border:none;" src="${baseUrlPlugPlayer}?id=${this.state.id_editar}"></iframe>\n<script src="https://plug-blogplay.s3.amazonaws.com/startPlug.js"></script>`)}>
                    <Assignment />
                  </IconButton>
                </>
              }
            </>
          }
          <br />

          <div className={"content_img"} style={{ width: 'calc(50vw - 200px)' }}>
            <span>{"Imagem de Capa"}</span>

            <label htmlFor="icon-button-photo">
              <div style={{ color: "#ff0000", fontSize: 12, marginBottom: 0 }}>
                {this.state.imageValid ? "" : "Imagem fora dos padrões!"}
              </div>

              <div
                className={"input_image"}
                style={{
                  backgroundImage: "url(" + this.state.imagePreviewUrl + ")",
                }}
              >
                {/*  <div style={{ color: "#6d6d6d", fontSize: 11, marginBottom: 0 }}>{this.state.insert.img.name}</div> */}

                <input
                  accept="image/jpeg, image/png"
                  className={classes.input_hidde}
                  id="icon-button-photo"
                  onChange={(evt) => this.setImg(evt)}
                  type="file"
                />

                <p className={"vertical_center_text"}>
                  {this.state.imagePreviewUrl
                    ? ""
                    : "Imagem 1:1 1400px à 3000px"}
                </p>
              </div>
            </label>
          </div>

          <div className={"content_img"} style={{ width: 'calc(50vw - 200px)' }}>
            <span>{"Cliente logo"}</span>

            <label htmlFor="inputLogo">
              <div style={{ color: "#ff0000", fontSize: 12, marginBottom: 0 }}>
                {""}
              </div>

              <div
                className={"input_image"}
                style={{
                  backgroundImage: "url(" + this.state.logoPreviewUrl + ")",
                }}
              >
                {/*  <div style={{ color: "#6d6d6d", fontSize: 11, marginBottom: 0 }}>{this.state.insert.img.name}</div> */}

                <input
                  accept="image/jpeg, image/png"
                  className={classes.input_hidde}
                  id="inputLogo"
                  onChange={(evt) => this.setImgLogo(evt)}
                  type="file"
                />

                <p className={"vertical_center_text"}>
                  {this.state.logoPreviewUrl ? "" : "Logo do cliente"}
                </p>
              </div>
            </label>
          </div>

          <button className={"input-insert"} onClick={this.inserir_editar}>
            {this.state.id_editar == -1 ? (
              <span>Salvar</span>
            ) : (
              <span>Salvar edição</span>
            )}{" "}
          </button>
        </div>{" "}
        <br />
        <div style={{ float: 'right', marginBottom: '15px' }}>
          <button onClick={this.prevPage} style={{ marginRight: '10px' }}>Página Anterior</button>
          <button onClick={this.nextPage}>Próxima página</button>
        </div>
        <br />
        <div className={"content_dados"}>
          <table
            className={
              "custom-table custom-table-horizontal custom-table-highlight"
            }
          >
            <thead>
              <tr>
                <th>ID</th>
                <th>Tipo</th>
                <th>Nome</th>
                <th>Autor Áudios</th>
                <th>Login</th>
                <th>Título</th>
                <th>E-mail</th>
                <th>Cadastro</th>
                <th>Site</th>
                <th>Categoria</th>
                <th>Limite de Áudios</th>
                <th>Áudios Produzidos</th>
                <th>Limite de Carácteres</th>
                <th>Carácteres Usados</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {this.state.dados.map((item) => {
                return (
                  <tr>
                    <td>{item.id}</td>
                    <td>{clientTypes[item.clientType]}</td>
                    <td>{item.nome}</td>
                    <td>{item.nomeAuthor ? item.nomeAuthor : "NossaVoz"}</td>
                    <td>{item.login}</td>
                    <td>{item.titulo_podcast}</td>
                    <td>{item.email}</td>
                    <td>{moment(item.createdAt).format("DD/MM/YYYY")}</td>
                    <td style={{ 'max-width': '200px', 'overflow': 'hidden', 'text-overflow': 'ellipsis' }} ><a href={item.site.includes('http') ? item.site : `https://${item.site}`} target={"_blank"}>{item.site}</a></td>
                    <td>{item.categoria}</td>
                    <td>{item.clientType == blogPlayClientType ? item.monthlyAudios : ''}</td>
                    <td>{item.clientType == blogPlayClientType ? item.audiosOnMonth ?? 0 : ''}</td>
                    <td>{item.clientType == plugClientType ? item.monthlyCharacters : ''}</td>
                    <td>{item.clientType == plugClientType ? item.charCount ?? 0 : ''}</td>
                    <td>
                      <button onClick={(_) => this.editar(item)}>editar</button>{" "}
                      |{" "}
                      <button onClick={(_) => this.excluir(item.id)}>
                        excluir
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default withStyles(useStyles)(Cliente);
